/**
 * File upload component for images and videos
 */

import { Upload, X } from "lucide-react";
import ListingDetailsForm from "@/components/ListingDetailsForm";

export function FileUpload({
  inputType,
  inputFile,
  setInputFile,
  showListingDetails,
  setShowListingDetails,
  listingType,
  setListingType,
  listingDetails,
  setListingDetails,
  textPosition,
  setTextPosition
}) {
  const isImage = inputType === "image";
  const acceptType = isImage ? "image/*" : "video/*";
  const fileTypes = isImage ? "PNG, JPG, WEBP" : "MP4, MOV";
  const maxSize = isImage ? "10MB" : "100MB";

  return (
    <div>
      <label className="text-sm font-medium mb-2 block">
        Upload your {isImage ? "image" : "video"}
      </label>
      
      {!inputFile ? (
        <label className="flex flex-col items-center justify-center w-full h-32 border-2 border-dashed border-white/20 rounded-xl cursor-pointer hover:border-viraly-orange/50 hover:bg-viraly-orange/5 transition-all">
          <Upload className="w-8 h-8 text-viraly-muted mb-2" />
          <p className="text-sm text-viraly-light">Click to upload or drag & drop</p>
          <p className="text-xs text-viraly-muted mt-1">
            {fileTypes} up to {maxSize}
          </p>
          <input
            type="file"
            className="hidden"
            accept={acceptType}
            onChange={(e) => e.target.files?.[0] && setInputFile(e.target.files[0])}
            data-testid={`input-${inputType}-file`}
          />
        </label>
      ) : (
        <div className="relative">
          {isImage ? (
            <img 
              src={URL.createObjectURL(inputFile)} 
              alt="Preview" 
              className="w-full h-32 object-cover rounded-xl"
            />
          ) : (
            <video 
              src={URL.createObjectURL(inputFile)} 
              className="w-full h-32 object-cover rounded-xl"
              controls
            />
          )}
          <button
            onClick={() => setInputFile(null)}
            className="absolute top-2 right-2 w-7 h-7 rounded-full bg-red-500 flex items-center justify-center hover:bg-red-600 transition-colors"
            data-testid="remove-file-btn"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
      )}
      
      {/* Listing Details */}
      {inputFile && (
        <div className="mt-4">
          <ListingDetailsForm
            showListingDetails={showListingDetails}
            setShowListingDetails={setShowListingDetails}
            listingType={listingType}
            setListingType={setListingType}
            listingDetails={listingDetails}
            setListingDetails={setListingDetails}
            textPosition={textPosition}
            setTextPosition={setTextPosition}
          />
        </div>
      )}
    </div>
  );
}
